import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CommandeService } from 'src/app/core/services/commande.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';


@Component({
  selector: 'app-expediteurpopup',
  templateUrl: './expediteurpopup.component.html',
  styleUrls: ['./expediteurpopup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpediteurpopupComponent implements OnInit {

  titre: string = '';
  expediteurForm: FormGroup;
  chargement = false;
  voirBtnEnregistrer = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any
, private fb: FormBuilder
, private messageService: MessageService
, private toastService: ToastService
, public commandeService: CommandeService
, private dialogRefContact: MatDialogRef<ExpediteurpopupComponent>) {
  this.expediteurForm = this.fb.group({
    id: [null],
    nom: ['', Validators.required],
    prenom: ['', Validators.required],
    telephone: ['', Validators.required],
    userId: ['']
  });
 }

  ngOnInit(): void {
    if(this.data.typeOperation == 'ajout' ) {
      this.titre = 'Ajouter un Expéditeur';
    } else if(this.data.typeOperation == 'modif' ) {
      this.titre = 'Modifier un Expéditeur';
      this.afficherExpediteur();
    }
  }

  afficherExpediteur() {
    this.expediteurForm.patchValue({ id: this.data.contact.id });
    this.expediteurForm.patchValue({ nom: this.data.contact.nom });
    this.expediteurForm.patchValue({ prenom: this.data.contact.prenom });
    this.expediteurForm.patchValue({ telephone: this.data.contact.telephone });
    this.expediteurForm.patchValue({ userId: this.data.contact.userId });

    this.expediteurForm.value['id'] = this.data.contact.id;
    this.expediteurForm.value['nom'] = this.data.contact.nom;
    this.expediteurForm.value['prenom'] = this.data.contact.prenom;
    this.expediteurForm.value['telephone'] = this.data.contact.telephone;
    this.expediteurForm.value['userId'] = this.data.contact.userId;
  }

  onSubmit() {
    if (this.expediteurForm.invalid) {
      this.expediteurForm.markAllAsTouched();
      return;
    }

    var telephone: String = this.expediteurForm.value['telephone'];
    if (telephone.length !== 10) {
      this.expediteurForm.get('telephone')?.setErrors({ 'invalidLength': true });
      return;
    }

    if (this.data.typeOperation == 'ajout') {
      this.enregistrerExpediteur();
    } else if (this.data.typeOperation == 'modif') {
      this.modifierExpediteur();
    }
  }

  enregistrerExpediteur() {
    this.chargement = true;
    this.commandeService.enregistrerExpediteur(this.expediteurForm.value).subscribe(
      (reponse) => {
        this.chargement = false;
        this.expediteurForm.patchValue({ id: reponse.id });
        this.toastService.succes('Expéditeur enregistré avec succès');
        this.dialogRefContact.close(this.expediteurForm.value);
      },
      (erreur) => {
        this.chargement = false;
        this.voirBtnEnregistrer = true;
        this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
      }
    );
  }

  modifierExpediteur() {
    this.chargement = true;
    this.commandeService.modifierExpediteur(this.expediteurForm.value).subscribe(
      (reponse) => {
        this.chargement = false;
        this.toastService.succes('Expéditeur modifié avec succès');
        this.dialogRefContact.close(this.expediteurForm.value);
      },
      (erreur) => {
        this.chargement = false;
        this.voirBtnEnregistrer = true;
        this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
      }
    );
  }

}
